import { getHistory, getActiveSessions } from '@/api/home-request'
export default {
    state: {
        history: [],
        active: [],
        current: {}


    },

    mutations: {

        SET_HOME_REQUEST_HISTORY: (state, data) => {
            state.history = [...data]
        },
        SET_HOME_REQUEST_ACTIVE: (state, data) => {
            state.active = data
        },
        SET_CURRENT_HOME_REQUEST: (state, data) => {
            state.current = data
        }

    },

    actions: {
        getHistory({ commit }) {

            return new Promise((resolve, reject) => {
                getHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_HOME_REQUEST_HISTORY', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getActiveSessions({ commit }) {
            commit('SET_HOME_REQUEST_ACTIVE', [])
            commit('SET_TABLE_TEXT', true)
            commit("SET_PROGRESS_SHOW", true);
            return new Promise((resolve, reject) => {
                getActiveSessions().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_HOME_REQUEST_ACTIVE', data)
                    commit('SET_TABLE_TEXT', false)
                    commit("SET_PROGRESS_SHOW", false);

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },



    }
}